import { Image } from "@chakra-ui/react";
import React from "react";

export const Reminder = React.memo(() => {
  return (
    <Image
      marginX={{ base: 2, sm: 4 }}
      marginY={2}
      src={require("assets/personal-reminder.png")}
      maxW="400px"
    />
  );
});
